export const GET_ORGANISATION_ROLES = 'GET_ORGANISATION_ROLES';
export const SET_ORGANISATION_ROLES = 'SET_ORGANISATION_ROLES';
export const CREATE_ROLE = 'CREATE_ROLE';
export const UPDATE_ROLE = 'UPDATE_ROLE';
export const DELETE_ROLE = 'DELETE_ROLE';
